export default __webpack_public_path__ + "static/media/paypal.48e007fa.svg";